import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketingPageHeader from "@/components/MarketingPageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Globe, Sparkles, Puzzle, Target } from "lucide-react";
import { useTranslation } from "react-i18next";

const PuzzleApp = () => {
  const { t } = useTranslation();

  const features = [
    { icon: Sparkles, title: t("puzzleStudent.appLanding.features.aiGenerated.title"), description: t("puzzleStudent.appLanding.features.aiGenerated.description") },
    { icon: Target, title: t("puzzleStudent.appLanding.features.personalized.title"), description: t("puzzleStudent.appLanding.features.personalized.description") },
    { icon: Puzzle, title: t("puzzleStudent.appLanding.features.activePractice.title"), description: t("puzzleStudent.appLanding.features.activePractice.description") },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <MarketingPageHeader
        eyebrow={
          <div className="inline-flex items-center gap-2 rounded-full bg-primary/15 px-3 py-1 text-xs font-medium text-foreground">
            <Globe className="w-3.5 h-3.5" />
            {t("puzzleStudent.appLanding.badge")}
          </div>
        }
        title={t("puzzleStudent.appLanding.heading")}
        subtitle={t("puzzleStudent.appLanding.intro")}
        containerClassName="max-w-5xl"
      />
      <main className="container mx-auto px-4 pb-24 pt-6 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {features.map((feature) => (
            <Card key={feature.title} className="bg-secondary/50">
              <CardContent className="p-6">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3">
                  <feature.icon className="w-5 h-5 text-foreground" />
                </div>
                <h3 className="font-semibold text-foreground mb-1">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PuzzleApp;
